<ng-container>
    <div class="mx-4 policy-administration-container my-5">
        <form [formGroup]="policyAdministrationForm" class="mt-3 ms-2">
            <h4>Policy Administration</h4>
            <div [ngClass]="{ 'disabled-div': isReadOnly()}" class="row mb-2 me-3 form-container">
                <label title="Please select amendment you wish to make to the policy" htmlFor="mtachangeType" class="form-label required">What would you like to do?</label>
                <select id="mtachangeType" formControlName="requestChangeType" class="form-select form-select-lg form-select-solid select2-hidden-accessible mx-2">
                    <option [value]="''">Select</option>
                    <option *ngFor="let mtaChange of this.mtaChangeList()" [value]="mtaChange.gencodeId">
                        {{mtaChange.code}}
                    </option>
                </select>
                <div *ngIf="policyAdministrationForm.get('requestChangeType')?.invalid && policyAdministrationForm.get('requestChangeType')?.touched" class="text-danger">
                    What would you like to do? field is required
                </div>
            </div>
            <div class="row mb-2 me-3 form-container">
                @if(this.authService.isBroker() && this.policyAdministrationForm.get('responseDescription')?.value) {
                    <p class="py-3"><b>Admin Response: </b> {{this.policyAdministrationForm.get('responseDescription')?.value }}</p>
                }
                @if(this.authService.isUwAdmin() && this.policyAdministrationForm.get('requestDescription')?.value) {
                    <p class="py-3"><b>Broker Response: </b> {{this.policyAdministrationForm.get('requestDescription')?.value }}</p>
                }
            </div>
            <div class="row mb-2 me-3 form-container">
                <label htmlFor="descriptionMtaChange" class="form-label">Description</label>
                @if(this.authService.isBroker()){
                    <textarea class="mx-2" id="descriptionMtaChange" formControlName="requestDescription" rows="5" cols="10" maxlength="1000"></textarea>
                }
                @if(this.authService.isUwAdmin()){
                    <textarea class="mx-2" id="descriptionMtaChange" formControlName="responseDescription" rows="5" cols="10" maxlength="1000"></textarea>
                }
            </div>
            <div [ngClass]="{ 'disabled-div': isReadOnly()}" class="row mb-2 me-3 form-container">
                <label title="Please select when you require amendment to policy take place" htmlFor="requestDate" class="form-label required">Change start date</label>
                <input id="requestDate" class="form-control form-control-solid mx-2" formControlName="requestDate" [min]="policyStartDate()" type="date" name="changeDate" />
                <div *ngIf="policyAdministrationForm.get('requestDate')?.invalid && policyAdministrationForm.get('requestDate')?.touched" class="text-danger">
                    Change start date is required
                </div>
            </div>
        </form>
        <div class="mt-5 ms-2">
            <div class="row flex justify-content-between align-items-center">
                <!-- Response Message displayed here -->
                 @if(this.authService.isBroker()){
                    @if(this.policyAdministrationForm.get('adjustmentLocked')?.value === 1 && this.policyAdministrationForm.get('reviewUserResponse')?.value === null){
                        <h6 class="col-12 mb-5">Your changes have been referred to the Underwriting Admin</h6>
                    }
                    @if(this.policyAdministrationForm.get('reviewUserResponse')?.value === 1 && this.policyAdministrationForm.get('adjustmentLocked')?.value === 1){
                        @if(this.policyAdministrationForm.get('requestUserResponse')?.value === null && this.policyAdministrationForm.get('requestUserResponse')?.value === null){
                            <h6 class="col-6 mb-5">Policy is Amended</h6>
                        }
                    }
                    @if(this.policyAdministrationForm.get('reviewUserResponse')?.value === 1 && this.policyAdministrationForm.get('adjustmentLocked')?.value === 1){
                        @if(this.policyAdministrationForm.get('requestUserResponse')?.value === 1){
                            <h6 class="col-12 mb-5">Quote MTA Changes Accepted</h6>
                        }@else if(this.policyAdministrationForm.get('requestUserResponse')?.value === 0){
                            <h6 class="col-12 mb-5">Quote MTA Changes Declined</h6>
                        }
                    }

                    @if(this.policyAdministrationForm.get('adjustmentLocked')?.value === 0){
                        @if (this.policyAdministrationForm.get('responseChangeBound')?.value) {
                            <h6 class="col-12 mb-5">MTA Bind Completed</h6>
                        }@else if(this.policyAdministrationForm.get('reviewUserResponse')?.value === 0){
                            <h6 class="col-12 mb-5">Your changes request has been declined by Underwriting Admin</h6>
                        }
                    }
                 }
                 @if(this.authService.isUwAdmin()){
                    @if(this.policyAdministrationForm.get('adjustmentLocked')?.value === 0){
                        @if (this.policyAdministrationForm.get('responseChangeBound')?.value) {
                            <h6 class="col-12 mb-5">MTA Bind Completed</h6>
                        }@else if(this.policyAdministrationForm.get('reviewUserResponse')?.value === 0){
                            <h6 class="col-6 mb-5">Change request declined</h6>
                        }
                    }

                    @if(this.policyAdministrationForm.get('reviewUserResponse')?.value === 1 && this.policyAdministrationForm.get('adjustmentLocked')?.value === 1){
                        @if(this.policyAdministrationForm.get('requestUserResponse')?.value === null && this.policyAdministrationForm.get('requestUserResponse')?.value === null){
                            <h6 class="col-6 mb-5">Policy is Amended</h6>
                        }
                    }

                    @if(this.policyAdministrationForm.get('reviewUserResponse')?.value === 1 && this.policyAdministrationForm.get('adjustmentLocked')?.value === 1){
                        @if(this.policyAdministrationForm.get('requestUserResponse')?.value === 1){
                            <h6 class="col-12 mb-5">Quote MTA Changes Accepted</h6>
                        }@else if(this.policyAdministrationForm.get('requestUserResponse')?.value === 0){
                            <h6 class="col-12 mb-5">Quote MTA Changes Declined</h6>
                        }
                    }
                }
                @if(this.isQuoteMTA()){
                    <h6 class="col-6 mb-5">Policy is Amended</h6>
                }
                @if(this.policyAdministrationForm.get('adjustmentLocked')?.value === 0 && this.policyAdministrationForm.get('responseChangeBound')?.value){
                    <div class="col-12">
                        <h6 (click)="onViewandDownloadDocumentAction()"  class="text-blue text-decoration-underline mb-5 cursor-pointer">Download Endorsement Document</h6>
                    </div>
                }

            </div>
        </div>
    </div>
    <mat-action-row class="accordion-footer d-flex align-items-stretch justify-content-between py-5 px-6">
        <div class="d-flex align-items-center me-3">
            <img src="assets\icon-assets\png\save-exit-icon.png" alt="Save and Exit" (click)="onSaveAndExitHomeAction()" class="h-40px w-40px cursor-pointer bg-white border border-1 border-secondary p-2 rounded" draggable="false" />
        </div>
        <div class="d-flex">
            @if(this.authService.isBroker()){
                @if(this.policyAdministrationForm.get('adjustmentLocked')?.value !== 1){ 
                    @if(!this.policyAdministrationForm.get('responseChangeBound')?.value){
                        <div [attr.title]="policyAdministrationForm.invalid ? 'Please fix the errors in the form.' : null">
                            <button mat-button type="button" (click)="onRequestChange()" [disabled]="this.policyAdministrationForm.invalid" class="btn btn-lg btn-primary continue-btn">Request Change</button>
                        </div>
                    }
                }@else if(this.policyAdministrationForm.get('requestDate')?.value){
                    @if(this.policyAdministrationForm.get('reviewUserResponse')?.value === 1 && this.policyAdministrationForm.get('requestUserResponse')?.value === null) {
                        <button type="button" class="btn btn-lg btn-light-primary continue-btn me-3" id="indication-next-1" (click)="onDeclineMTAChange()">Decline</button>
                        <button type="button" class="btn btn-lg btn-primary me-3 back-btn" id="indication-next-1" (click)="onAcceptMTAChange()">Accept </button>
                    }@else if(this.policyAdministrationForm.get('requestUserResponse')?.value === 0){
                        <button mat-button type="button" (click)="onRequestChange()" [disabled]="this.policyAdministrationForm.invalid" class="btn btn-lg btn-primary continue-btn">Request Change</button>
                    }
                }


             

            }
            @if(this.authService.isUwAdmin()){
                @if(this.isQuoteMTA()){
                    <button mat-button type="button" (click)="onQuoteMTASubmit()" class="btn btn-lg btn-primary continue-btn">Submit</button>
                }@else if(this.policyAdministrationForm.get('requestDate')?.value){
                    @if(this.policyAdministrationForm.get('adjustmentLocked')?.value !== 0 && this.policyAdministrationForm.get('reviewUserResponse')?.value === null){
                        <button type="button" (click)="onDeclineRequestChange()" class="btn btn-lg btn-light-primary continue-btn me-3">Decline Change Request</button>
                        <button mat-button type="button" (click)="onQuoteMTAChange()" class="btn btn-lg btn-primary continue-btn">Quote MTA</button>
                    }@else if(this.policyAdministrationForm.get('requestUserResponse')?.value === 1 && this.policyAdministrationForm.get('responseChangeBound')?.value === null){
                        <button mat-button type="button" (click)="onBindMTAChange()" class="btn btn-lg btn-primary continue-btn">Bind MTA</button>
                    }
                }
            }
        </div>                                                        
    </mat-action-row>
    <!----------- Endorsement Document ------------->
    <app-endorsement-document></app-endorsement-document>
</ng-container>